import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import config from '../config.json';
import NavMenu from './NavMenu';

const apiUrl = config.apiUrl;
const Home = () => {
  const [transactionsCountData, setTraansactionsCountData] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const roles = JSON.parse(localStorage.getItem('Roles'));

  const userAccess = {
    hasView: roles?.includes('View') || false,
    hasAdmin: roles?.includes('Admin') || false,
    hasApprover: roles?.includes('Approver') || false,
    hasStandard: roles?.includes('Standard') || false,
    hasReviewer: roles?.includes('Reviewer') || false,
    };

  const { hasView, hasAdmin, hasStandard, hasApprover, hasReviewer } = userAccess;

  useEffect(() => {
    redirectToPath();
  }, []);

  const redirectToPath = () => {
    // Navigate to the report view path if the user is an admin
    if (hasAdmin) {
      navigate('/reportviews');
    }
    else if(hasStandard) {
      navigate('/employee-list');
    }
    else if (hasReviewer) {
      navigate('/reportviews');
    }
  };

  useEffect(() => {
    // Fetch overtime data when the component mounts
    fetchTransactionsCountData();
  }, []);

  const fetchTransactionsCountData = async () => {
    const token = localStorage.getItem('token');
    try {

      const response = await fetch(`${apiUrl}/ReportView/TransactionsCount`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const result = await response.json();
        setTraansactionsCountData(result);
      }
    } catch (error) {
      setErrorMessage('Error fetching data');
      setSuccessMessage('');
    }
  };

  return (
    <div>
      {hasApprover ? (
        <>
          <h3>For Approval</h3>
          {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
          {successMessage && <div className="alert alert-success">{successMessage}</div>}
          <p>Overtime: {transactionsCountData?.Overtime || 0}</p>
          <p>Leave: {transactionsCountData?.Leave || 0}</p>
          <p>Undertime: {transactionsCountData?.Undertime || 0}</p>
          <p>Time Entries: {transactionsCountData?.TimeEntry || 0}</p>
        </>
      ) : (
        <div>
          <h3>No access!</h3>
          <button className="btn btn-primary" onClick={() => navigate(-1)}>
            Go Back
          </button>
        </div>
      )}
    </div>
  )
};

export default Home;
